// MUI レイアウトコンポーネント（Box, Grid, Stack）をインポート
import { Box, Grid, Stack } from '@mui/material';
// React から RefObject 型をインポート
import { RefObject } from 'react';
// react-router-dom から useLocation, useParams フックをインポート
import { useLocation, useParams } from 'react-router-dom';
// スクロールトップボタンコンポーネントをインポート
import { ScrollToTopButton } from 'src/components/app-components/bonsai/ScrollToTopButton';
// 保存ボタンコンポーネントをインポート
import { EnqueteAnswerSpecialQuestionCompliaSaveButtons } from 'src/features/general/enquete-answer/components/pages/input/components/header-box/components/EnqueteAnswerSpecialQuestionCompliaSaveButtons';
// ファイル型定義をインポート
import { FileType } from 'src/features/general/enquete-answer/store/enqueteAnswerSlice';
// 要素の画面表示判定フックをインポート
import { useElementOnScreen } from 'src/hooks/useElementOnScreen';
// 浮動保存ボタンのプロパティ型を定義
type EnqueteAnswerSpecialQuestionCompliaFloatingSaveButtonsProps = {
  // 対象要素の参照（RefObject）
  targetRef: RefObject<Element>;
  // 選択されたファイルのリスト
  selectedFile: FileType[];
  // 削除されたファイルのリスト
  deletedFile: FileType[];
  // ファイル選択ボックスの開閉状態設定関数
  setIsSelectFileBoxOpen: any;
};
// 浮動保存ボタンコンポーネントの定義
export const EnqueteAnswerSpecialQuestionCompliaFloatingSaveButtons = ({
  // プロパティから対象要素の参照を取得
  targetRef,
  // プロパティから選択されたファイルを取得
  selectedFile,
  // プロパティから削除されたファイルを取得
  deletedFile,
  // プロパティからファイル選択ボックス開閉設定関数を取得
  setIsSelectFileBoxOpen,
}: EnqueteAnswerSpecialQuestionCompliaFloatingSaveButtonsProps) => {
  // URL パラメータから回答者ターゲット ID を取得
  const respondentTargetId = useParams().id;
  // URL クエリパラメータから確認リクエスト ID を取得
  const confirmRequestId: string | null = new URLSearchParams(useLocation().search).get('confirmRequestId');

  // 対象要素が画面に表示されているかを判定するフックを使用
  const isVisible = useElementOnScreen(targetRef, {
    // ルート要素（null はビューポート）
    root: null,
    // ルートからのマージン
    rootMargin: '0px',
    // 閾値（0 は要素が少しでも見えたら判定）
    threshold: 0,
  });

  // 要素が表示されている場合は何もしない（null を返す）
  if (isVisible) {
    return null;
  }

  // JSX レンダリング開始
  return (
    // 固定位置配置の Box コンポーネント（右下）
    <Box sx={{ position: 'fixed', bottom: 10, right: 2, mr: 6, mb: 2 }}>
      {/* 右寄せのグリッドレイアウトコンテナ */}
      <Grid container justifyContent="flex-end">
        {/* 保存ボタン配置用のスタック */}
        <Stack>
          {/* コンプライアンス保存ボタンコンポーネント */}
          <EnqueteAnswerSpecialQuestionCompliaSaveButtons
            // 回答者ターゲット ID を設定（null 対策）
            respondentTargetId={respondentTargetId ?? ''}
            // 確認リクエスト ID を設定（null 対策）
            confirmRequestId={confirmRequestId ?? ''}
            // 選択されたファイルを設定
            selectedFile={selectedFile}
            // 削除されたファイルを設定
            deletedFile={deletedFile}
            // ファイル選択ボックス開閉設定関数を設定
            setIsSelectFileBoxOpen={setIsSelectFileBoxOpen}
            // 上部表示フラグ（false）
            topFlg={false}
          />
        </Stack>
        {/* スクロールトップボタン配置用のスタック（マージン設定） */}
        <Stack sx={{ ml: 2, mt: 7 }}>
          {/* スクロールトップボタンコンポーネント */}
          <ScrollToTopButton />
        </Stack>
      </Grid>
    </Box>
  );
};
